var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetardanciaFuego(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6C6C6C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.8,179.7c-0.4,0-0.8,0-1.2,0l-8.7-0.7l7.9-3.6c1-0.4,24-11.4,19.8-41.4c-1.5,1.4-3.2,2.7-5,3.9 c-6.7,4.2-12.8,4.5-17.8,0.9c-6.5-4.9-3.2-9.7-0.4-14.1c3.1-4.7,7-10.5,4.6-20.1c-2.7-10.8-6.9-16.2-9.9-18.8 c1.1,8.7,1.2,26.7-14.3,40.2c-19,16.6-14.5,30.4,0.3,50.2l2.7,3.6h-4.4c-0.4,0-37.2-0.5-47.7-42.2c-6.1-24.4,3.7-37.5,10.9-47 c5.4-7.1,7.8-10.8,4.5-15.7c-4.1-6.1-7.8-13-5-17.6c2.3-3.8,8-5,19.7-4c-0.7-10-1.5-43.2,19.5-50.3c23.7-7.9,37,2.5,37.5,3l2.4,1.9 l-2.6,1.7c-0.1,0-9.9,6.7-11.6,16.6c-0.9,5.2,0.7,10.5,4.5,15.7c3.8,4.8,7.8,9.4,12.1,13.8c18.4,19.7,43.8,46.6,31.3,82 c-8.1,23-21.3,33.2-30.9,37.7C114.3,178.1,108.1,179.5,101.8,179.7z M50.6,57.4c-5.9,0-8.1,1.1-8.8,2.1c-0.7,1.1-0.5,4.5,5,12.7 c5.1,7.8,0.4,14.1-4.8,20.8c-7,9.3-15.7,20.9-10.1,43.2c7.5,29.6,29,36.7,38.6,38.3c-13.2-19-16.7-34.7,3.3-52.2 c18.9-16.5,12.3-39.7,11.9-40.8l-1.1-3.7l3.8,1C89,79,100,82,105.4,103.3c2.9,11.6-2,18.9-5.2,23.7c-3.2,4.8-3.6,5.8-0.7,8 c8.3,6.2,19.6-7.1,19.8-7.2l3-3.5l1,4.5c5.3,24.4-5.9,38.8-14,45.6c10.3-2.2,27.7-10.2,37.6-38.3c11.6-32.8-12.6-58.7-30.3-77.5 c-4.4-4.5-8.5-9.1-12.4-14c-4.7-6.2-6.4-12.7-5.3-19.1c1.4-8.3,7.3-14.5,10.8-17.5c-4.5-2.3-15-5.9-30.8-0.7 c-20.9,7-16.2,47.9-16.2,48.3l0.3,2.8l-2.8-0.3C56.9,57.7,53.8,57.4,50.6,57.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetardanciaFuego);
export default __webpack_public_path__ + "static/media/retardancia-fuego.853aa31bafa95399704d3bdfd5a7c3f2.svg";
export { ForwardRef as ReactComponent };